// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3LIzH","modalForm":"UpgradeEpcsModal_modalForm__1v8U5","modalFooter":"UpgradeEpcsModal_modalFooter__3RO3W"};